<template>
    <v-layout row wrap>
        <v-flex class="xs12 body-2">
            {{ subLabel }}
        </v-flex>
        <v-flex class="xs12">
            <v-select
                v-model="item"
                data-testid="drop-down"
                class="body-2 tz-dropdown"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                outline
                append-icon="fa-solid fa-angle-down"
                :items="finalPatientsList"
                item-text="label"
                item-value="uuid"
                return-object
                :label="$t('form.selectNam')"
                filled
                :disabled="disabled"
                :rules="[
                    requiredField()
                ]"
                @change="handleOnChange"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { find, findIndex, isNil, map, replace, toLower } from 'lodash';
import { formRules } from '@/mixins/form-rules';
import { authModule } from '@/utils';
export default {
    name: 'patient-selector',
    mixins: [formRules],
    props: {
        subLabel: { type: String, required: true, default: '' },
    },
    data() {
        return {
            item: undefined,
            disabled: false,
        };
    },

    created() {
        if (this.serviceHasDynamicFilter) {
            // try to find correspondant profile from finalPatientList with first_name and last_name
            const firstNameIndex = findIndex(this.getDynamicFilterMetadataValues, ['associatedMetadata', 'first_name']);
            const lastNameIndex = findIndex(this.getDynamicFilterMetadataValues, ['associatedMetadata', 'last_name']);
            if (firstNameIndex !== -1 && lastNameIndex !== -1) {
                const dynamicServiceFilterMetadataLabel = toLower(this.getDynamicFilterMetadataValues[firstNameIndex].value + this.getDynamicFilterMetadataValues[lastNameIndex].value);
                const findItem = find(this.finalPatientsList, function(patient) {
                    const compareLabel = toLower(patient.firstName) + toLower(patient.lastName);
                    return compareLabel === dynamicServiceFilterMetadataLabel;
                });

                if (findItem) {
                    this.item = findItem;
                    this.handleOnChange(this.item);
                    return;
                }
            }
            this.item = find(this.finalPatientsList, { uuid: -1 });
            this.handleOnChange(this.item);
        }
        else if (this.getPatientDataToFillMetadataForm) {
            this.item = this.getPatientDataToFillMetadataForm;
            this.handleOnChange(this.getPatientDataToFillMetadataForm);
        }
        else {
            if (!isNil(this.finalPatientsList)) {
                this.item = find(this.finalPatientsList, { associationType: 'owner' });
                this.handleOnChange(this.item);
            }
        }
    },

    computed: {
        ...mapGetters({
            getPatients: `${authModule}/getPatients`,
            getLoggedUserCommunication: `${authModule}/getLoggedUserCommunication`,
            getPatientDataToFillMetadataForm: 'metadataForm/getPatientDataToFillMetadataForm',
            serviceHasDynamicFilter: 'services/serviceHasDynamicFilter',
            getDynamicFilterMetadataValues: 'services/getDynamicFilterMetadataValues',
        }),
        formattedPatientsList() {
            return map(this.getPatients, p => {
                let formatNam = replace(p.nam, /^(.{4})(\d{4})(\d{4})$/g, '($1 $2 $3)');
                if (formatNam) {
                    formatNam = ' - ' + formatNam;
                }
                const label = replace(`${p.firstName} ${p.lastName}${formatNam}`, /null|undefined/g, '');
                return {
                    ...p,
                    label,
                    ...this.getOwnerCommData,
                };
            });
        },
        finalPatientsList() {
            return [
                ...this.formattedPatientsList,
                {
                    uuid: -1,
                    label: this.$i18n.t('form.patientSelector.otherPatient'),
                    ...this.getOwnerCommData,
                },
            ];
        },
        getOwnerCommData() {
            if (!this.getLoggedUserCommunication) return {};
            const { cellphone, phone, email } = this.getLoggedUserCommunication;
            const replaceAreaCode = (str) => replace(str || '', /^[+]1/, '');
            return {
                email: email || '',
                cellphone: replaceAreaCode(cellphone),
                phone: replaceAreaCode(phone),
            };
        },
    },
    methods: {
        handleOnChange(value) {
            this.$store.commit('metadataForm/SET_CONFIRM_EMAIL', this.getOwnerCommData.email || '');
            this.$store.commit('metadataForm/SET_PROFILE_IDENTITY_STATE', this.item.identityState || '');
            this.$emit('onDropDownChange', value);
            this.$store.commit('metadataForm/SET_PATIENT_DATA_TO_FILL_METADATA_FORM', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.dropdown-title {
    font-size: 14px;
}
</style>
